import * as materials from "@lts/materials/legacy/legacy-shadowOnly";
export { materials };
export default materials;
